import { SolidarityCalculator } from '@/components/SolidarityCalculator';

const Index = () => {
  return <SolidarityCalculator />;
};

export default Index;